import { configureStore } from '@reduxjs/toolkit'
import {menuToggles ,menuActive} from "./reducer"

export default configureStore({
    reducer: {
        menuToggle : menuToggles,
        active : menuActive
    }
})